// --------------------------------------- Project List
export const ProjectList = [
  {
    img: "/Auble.png",
    title: "Auble : Rooted Journey: Know The Roots. ",
    description:
      "AUBLE is a platform that directly connects farmers with customers, offering organic products with full transparency. Customers can browse through a variety of organic goods, place orders, and enjoy on-door delivery. We prioritize transparency by providing information on where products came from, who planted them, and when they were harvested.",
    tech_stack: ["PHP","HTML","CSS", "MySQL","JavaScript"],
    github_url: "",
    demo_url: "https://auble.io/",
  },
  
  {
        img: "/one_piece_ultimate_icons_collection_by_knives1024_d7x8g4f-414w-2x.png",
    title: "MERN Manga",
    description:
            "A web application built using the MERN stack, which stands for MongoDB, Express.js, React.js, and Node.js.  ..",
        tech_stack: ["React JS", "Node.js", "ExpressJS", "MongoDB"],
    github_url: "https://github.com/1SuraZ/OnePeiceLibrary/tree/main/One-Piece-App-main",
        demo_url: "https://one-piece-app-01.onrender.com/signup/",
  },

  {
    img: "/mindfulliapp.jpg",
title: "Mindfulli App",
description:
        "An application built using the MERN stack and pockethost, which stands for MongoDB, Express.js, React.js, and Node.js.  ..",
    tech_stack: ["React JS", "Node.js", "ExpressJS", "MongoDB", "TailWind CSS","PocketHost"],
    github_url: "",
    demo_url: "https://mindfulli.app/",
},

  {
    img: "/StrengthForce.png",
    title: "StrengthForge App",
    description:
      "A web application for all your workout needs made for COMP231. ",
    tech_stack: ["React", "TailWind CSS","PocketHost", "Node.js" ],
    github_url: "https://github.com/1SuraZ/StrengthForce",
    demo_url: "https://strength-force.vercel.app/",
  },
  
];


export const stackList = [
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/html5/html5-original.svg",
    name: "HTML",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/css3/css3-original.svg",
    name: "CSS",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-original.svg",
    name: "JavaScript",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original.svg",
    name: "ReactJS",
  },

  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/git/git-original.svg",
    name: "Git",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original.svg",
    name: "React Native",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/nodejs/nodejs-original.svg",
    name: "NodeJS",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original.svg",
    name: "MongoDB",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
    name: "Python",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/flask/flask-original.svg",
    name: "Flask",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/c/c-original.svg",
    name: "C#",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
    name: "Java",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original.svg",
    name: "MySQL",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/bootstrap/bootstrap-original.svg",
    name: "Bootstrap",
  },
  
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/figma/figma-original.svg",
    name: "Figma",
  },
  
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/vscode/vscode-original.svg",
    name: "VS Code",
  },
];
